import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('feedback', {
    url: '/feedback',
    templateProvider: () =>
      import(/* webpackChunkName: "feedback" */ './feedback.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'feedbackCtrl as vm',
    requiredPermission: 'feedback',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "feedback" */ './feedback.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
          import('../../extensions/directives/date-range-picker'),
          import('../../extensions/directives/rome'),
          import('../../extensions/directives/validator-date'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
      gpsCustomerFeedbackType: GpsCustomerFeedbackType => GpsCustomerFeedbackType.find(
        { filter: { fields: { id: true, localName: true } } },
      ).$promise,
    },
  });
}

export default angular.module('app.feedback.routing', []).config(routes);
